<template lang="pug">
.channel-sidebar.inset.surface-bg.z1
  .channel-sidebar-item(v-nv)
    .csi-container.background(:class="{ 'inactive-element': !sidebar }")
      i.far.fa-list
  .channel-sidebar-item(v-nv)
    .csi-container.background(:class="{ 'inactive-element': sidebar === 'categories' }")
      i.fal.fa-filter
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "channel-sidebar",
  computed: {
    ...mapState("live", ["sidebar"])
  }
}
</script>

<style lang="scss" scoped>
.channel-sidebar {
  width: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0rem 0rem 1rem rgba(0, 0, 0, 50%) !important;

  .channel-sidebar-item {
    width: 40px;
    margin: 10px 0;
    height: 40px;
    position: relative;

    .csi-container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
    }
  }
}
</style>
